module.exports = __webpack_public_path__ + "static/media/randomNamePickerBackground.ce303637.svg";